<div class="relative" (keydown.escape)="isOpen.set(false)">
  <button
    type="button"
    class="context-selector__button"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    (click)="toggleOpen()"
  >
    <span class="context-selector__badge" aria-hidden="true">
      @if (selected()?.tenantAvatarUrl) {
        <img [src]="selected()!.tenantAvatarUrl" alt="" />
      } @else {
        {{ (selected()?.tenantName ?? '?').charAt(0).toUpperCase() }}
      }
    </span>
    <span class="context-selector__text">
      <span class="context-selector__title">{{ 'SIDEBAR.TENANT' | translate }}</span>
      <span class="context-selector__value">{{
        selected()?.tenantName ?? ('SIDEBAR.SELECT_TENANT' | translate)
      }}</span>
    </span>
    <mtm-icon class="context-selector__chevron" name="chevrons-up-down" [size]="14" />
  </button>

  @if (isOpen()) {
    <ul
      #list
      class="context-selector__list"
      role="list"
      [attr.aria-label]="'SIDEBAR.SELECT_TENANT' | translate"
      (scroll)="pagination.onListScroll(list)"
    >
      @for (tenant of pagination.tenants(); track tenant.tenantUuid) {
        <li role="listitem">
          <button type="button" class="context-selector__item" (click)="onSelect(tenant)">
            <span class="flex items-center gap-2">
              <span class="clamp-2 text-sm">{{ tenant.tenantName }}</span>
            </span>
          </button>
        </li>
      }
      @if (pagination.loading()) {
        <li role="listitem">
          <span class="context-selector__empty">{{ 'COMMON.LOADING' | translate }}</span>
        </li>
      }
    </ul>
  }
</div>
